import normalizeSpokenNumbers from './normalizeSpokenNumbers';

/**
 * Turns a reply into the text handed to the speech engine (ATAI-231).
 *
 * With `stripMarkup` (PropStream Intelligence, whose replies are markdown with
 * emojis) markdown markers and emojis are removed first, so the voice doesn't
 * read "asterisk asterisk" or an emoji's name. AI Search replies are plain
 * text and call this without `stripMarkup`, so their spoken output is exactly
 * normalizeSpokenNumbers(text), as before.
 *
 * Apply this ONLY to text handed to the speech engine — displayed chat text
 * keeps its own formatting.
 */
const EMOJI_PATTERN = /[\p{Extended_Pictographic}\u{1F1E6}-\u{1F1FF}\u{FE0F}\u{200D}\u{20E3}]/gu;

export const stripSpokenMarkup = (text) =>
  String(text)
    // fenced code blocks: keep the code, drop the fences
    .replace(/```[^\n]*\n?/g, '')
    // images and links: keep the visible text
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
    // headings, block quotes and list bullets at the start of a line
    .replace(/^[ \t]*#{1,6}[ \t]+/gm, '')
    .replace(/^[ \t]*>[ \t]?/gm, '')
    .replace(/^[ \t]*[-*+][ \t]+/gm, '')
    // horizontal rules and table divider rows (| --- | :---: |)
    .replace(/^[ \t]*([-*_])([ \t]*\1){2,}[ \t]*$/gm, '')
    .replace(/^[ \t]*\|?([ \t]*:?-{3,}:?[ \t]*\|)+[ \t]*(:?-{3,}:?[ \t]*)?$/gm, '')
    // bold / italic / strikethrough / inline-code markers
    .replace(/(\*\*|__|~~)(.+?)\1/g, '$2')
    .replace(/(^|[^\w*])\*(?!\s)([^*\n]+?)\*(?!\w)/g, '$1$2')
    .replace(/(^|[^\w_])_(?!\s)([^_\n]+?)_(?!\w)/g, '$1$2')
    .replace(/`([^`]*)`/g, '$1')
    // table pipes
    .replace(/[ \t]*\|[ \t]*/g, ' ')
    .replace(EMOJI_PATTERN, '')
    .replace(/[ \t]{2,}/g, ' ')
    .replace(/\n{3,}/g, '\n\n')
    .trim();

const prepareSpokenText = (text, { stripMarkup = false } = {}) =>
  normalizeSpokenNumbers(stripMarkup ? stripSpokenMarkup(text) : text);

export default prepareSpokenText;
